
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/boat-rental/[[...slug]]",
      function () {
        return require("private-next-pages/boat-rental/[[...slug]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/boat-rental/[[...slug]]"])
      });
    }
  